<template>
	<WebPlayer
		ref="webPlayer"
	>
		<WebPlayerFeedback
			ref="webPlayerFeedback"
			:on-submit-password="onSubmitPassword"
		/>
	</WebPlayer>
</template>

<script>
import WebPlayer from "lib/components/WebPlayer";
import WebPlayerFeedback from "lib/components/WebPlayerFeedback";
import alert from "lib/modules/Alert";
import http from "lib/modules/Http";

import parseISO from "date-fns/parseISO";

export default {
	name: "WebPlayerPage",
	components: {
		WebPlayer,
		WebPlayerFeedback
	},
	props: {
		downloadable: {
			type: Boolean,
			required: true
		},
		id: {
			type: String,
			required: true
		}
	},
	computed: {
		encodedId() {
			return encodeURIComponent(this.id);
		}
	},
	created() {
		this.passwordSubmitted = false;
	},
	mounted() {
		this.getMedia();
	},
	methods: {
		getMedia(password = "") {
			http.get(`/api/v2/media?type=meta&secid=${this.encodedId}&key=${password}`)
			.then((response) => {
				const hostname = response.data.recorder.server.hostname;
				const mediaItem = response.data;

				this.$refs.webPlayer.setup({
					file: `https://${hostname}/api/v2/media?type=video&secid=${this.encodedId}&key=${password}`,
					type: "mp4"
				});

				if (this.downloadable)
					this.$refs.webPlayer.addDownloadButton(mediaItem.title, parseISO(mediaItem.created));
			})
			.catch((error) => {
				if (error.response.status === 403 &&
				    typeof error.response.data.error !== "undefined"
				) {
					this.showWebPlayerFeedback(error.response.data.error.message);

					return;
				}

				alert.error("Unable to get media", error.response);
			});
		},
		showWebPlayerFeedback(errorMsg) {
			if (errorMsg.toLowerCase().indexOf("expire") === -1) {
				if (this.passwordSubmitted)
					this.$refs.webPlayerFeedback.show(true, "Wrong password, try again");
				else
					this.$refs.webPlayerFeedback.show(true, "This video is password protected");
			} else {
				this.$refs.webPlayerFeedback.show(false, "This link has expired");
			}
		},
		onSubmitPassword(password) {
			this.passwordSubmitted = true;
			this.getMedia(password);
		}
	}
};
</script>
